import React, { useEffect, useState } from 'react'
import { DialogBox } from '@softura/fluentuipackage'
import close from '../../assets/images/Close_SuccessPopup.svg'
import './PopupDilalogBox.scss'
import PrimaryButton from '../Button/PrimaryButton/PrimaryButtonContainer'
import OutlineButton from '../Button/OutlineButton/OutlineButtonContainer'
import { InputField } from '..'

interface IProps {
    hideDialog?: any,
    onDismiss?: any,
    Popupcontent?:any,
    popupOutlinebtnOnclick?:any,
    popupPrimarybtnOnclick?:any,
    orderDetails?:any,
    requestOption?:any
    selectedKey?:any
  }

const PopupDialogbox  = ({ hideDialog, onDismiss,Popupcontent,popupOutlinebtnOnclick,popupPrimarybtnOnclick,orderDetails,requestOption,selectedKey}:IProps) => {
    const [popupComments,setpopupComments] = useState(Popupcontent.comment);
    const [popupCommentError,setPopupCommentError] = useState(false)
    const popupcommentonchange = (_e:any,text:string) =>{
        if(text.length > 500){
            setPopupCommentError(true)
        }
        else{
            setPopupCommentError(false)  
        }
        setpopupComments(text)
        {Popupcontent.isCommentBoxRequire = false}
    }
    useEffect(()=>{
        setpopupComments(Popupcontent.comment)
    },[Popupcontent.comment])

    useEffect(()=>{
        if(popupComments?.length > 500){
            setPopupCommentError(true)
        }
        else{
            setPopupCommentError(false)
        }
    },[popupComments])

    const checkForRequestType = (index: any) => {
        if (requestOption[index]?.request =='Approve') {
            return <p><span className='fa fa-check-circle-o completed-btn'> </span> Approved </p>;
        } else if (requestOption[index]?.request =='Reject') {
            return <p><span className='fa fa-times-circle-o rejected-btn'> </span> Rejected</p>;
        } else {
            return <p><span className='fa fa-exclamation-circle returned-btn'> </span> Request More Info </p>;
        }
    }

    const checkForActionBy = () => {
        if (Popupcontent.actionby == 'ReturnSubmitbtn') {
            return <p><span className='fa fa-exclamation-circle returned-btn'> </span> Request More Info </p>
        } else if (Popupcontent.actionby == 'RejectSubmitBtn') {
            return <p><span className='fa fa-times-circle-o rejected-btn'></span> Rejected </p>
        } else {
            return <p><span className='fa fa-check-circle-o completed-btn'> </span> Approved </p>
        }
    }
    
    const getRequestOption = (index: any) => {
        if (requestOption?.length) {
            return checkForRequestType(index)
        } else {
            return checkForActionBy()
        }
    }

    const dialogContentProps = {
        title: <>
        <div className='popup-content'>
        <div className='close-btn-Popup'>
        <img src={close} alt='close' onClick={onDismiss}/>
        </div>
        <div className='popup-titleImg'>
        <img src={Popupcontent.titleImg} alt='close'/>
        </div>
        <div className={Popupcontent.isTitleWarning ? 'warning':'popup-title'}>
        <p>{Popupcontent.title}</p>
        </div>
        </div>
        </>,
        closeButtonAriaLabel: 'Close',
        subText: <div className='popup-subcontent'>
            <div className={Popupcontent.isTitleWarning ? 'popup-subtext-warning':'popup-subtext'}>{Popupcontent.subtextcontent}</div>
            <div className='popup-commentarea'>
            <div className={Popupcontent.isCommentboxVisible ? 'commentBox mb-3' : 'commentBox-Notshown'}><InputField multiline={true} row="3" value= { popupComments} resizable={false} placeholder='Comments' name='text' onChange={popupcommentonchange}/></div>
            {popupCommentError ? <span className='asset-validation-msg'>{"Please enter comments below 500 characters"}</span>:null}
            <div>
                    {orderDetails?.requests?.length && orderDetails?.requests.map((item: any, index: number) => {

                        return <div key={index} className={Popupcontent.isCompletedReportVisible ? 'completed-report mb-3' : 'completed-report-nonactive'}>
                            <div className='left-section'>
                                <p>{item.driverTitle }  / {item.description }</p>
                            </div>
                            <div className='right-section'>
                                {getRequestOption(index)}
                            </div>
                            
                        </div>
                    })
                    }
            </div>
          
            </div>
            <div className='popupbtn'>
            <OutlineButton text={Popupcontent.outlineBtnText} onClick={()=>popupOutlinebtnOnclick(Popupcontent.outlineBtnnavigateTo)}/>
            <PrimaryButton  text={Popupcontent.primaryBtnText} className={Popupcontent.isSingleConfirmationBtn ? 'singleBtnConfirmation' : ''} disabled={(Popupcontent.isCommentBoxRequire && !Popupcontent.comment) || (popupCommentError) ? true : false} onClick={()=>popupPrimarybtnOnclick(Popupcontent.primaryBtnnavigateTo,popupComments,Popupcontent.actionby,Popupcontent.value)}/>
            </div>
        </div>,
        styles:{
            subText: {
                 color:'black'
            }
        }
    };

    return (<>
      <DialogBox hideDialog={ hideDialog} dialogContentProps={dialogContentProps} selectedKey={selectedKey}>
      </DialogBox>
      </>
    )
  }
  
  export default PopupDialogbox